import Vuex from 'vuex'
import Vue from 'vue'


Vue.use(Vuex)

const state = {
   
}

const mutations = {
    SAVEORDER(state,orderInformation){
        state.orderInformation = orderInformation
    },
  
}

const actions = {
    saveOrder({commit},orderInformation){
        commit('SAVEORDER',orderInformation)
    },
}

const store = new Vuex.Store({
    state,
    mutations,
    actions,
})

export default store